import React from 'react';
import R from 'ramda';
import { Chip, FlatButton, FontIcon, Avatar } from 'material-ui';
const propTypes = {
  defaultShowNumOfPartners: React.PropTypes.number,
  partners: React.PropTypes.array.isRequired,
  justPartners: React.PropTypes.bool,
};
class EmailToPartners extends React.Component {
  constructor() {
    super();
    this.state = { showAllPartners: false };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const {
      partners, // must follow: [{ profileImageUrl, company_name or companyName, email }]
      defaultShowNumOfPartners,
      justPartners,
    } = this.props;
    const showAllPartners = this.state.showAllPartners;
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
        {
          !justPartners && (
            <b style={{ marginRight: '8px', fontSize: '20px' }}>TO: </b>
          )
        }
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {
            partners.slice(0, showAllPartners ? partners.length : defaultShowNumOfPartners).map((partner, i) => {
              const displayName = (() => {
                const companyName = partner.company_name || partner.companyName;
                if (companyName) return companyName;
                if (partner.email && partner.email !== 'via TourConnect') return partner.email;
                return 'Unknown';
              })();
              return (
                <Chip key={i} style={{ margin: '0 2px 2px 0', border: '1px solid #e0e0e0' }}>
                  { partner.profileImageUrl ?
                    <Avatar src={partner.profileImageUrl}/>
                    : <Avatar>{R.head(displayName)}</Avatar> }
                  {displayName} {partner.subText}
                </Chip>);
            })
          }
          {
            partners.length > defaultShowNumOfPartners ? (
              <FlatButton
                secondary
                hoverColor="none"
                style={{ fontSize: '12px', marginLeft: '8px' }}
                label={showAllPartners ? 'show less' : `show ${partners.length - 5}  more`}
                labelStyle={{ paddingLeft: '3px' }}
                labelPosition="after"
                onTouchTap={() => this.setState({ showAllPartners: !showAllPartners })}
              >
                <FontIcon style={{ fontSize: '16px', color: '#00BCD4', top: '2px' }} className={showAllPartners ? 'tc-icon-keyboard_arrow_up2' : 'tc-icon-keyboard_arrow_down2'}/>
              </FlatButton>
            ) : <div/>
          }
        </div>
      </div>
    );
  }
}
EmailToPartners.propTypes = propTypes;
export default EmailToPartners;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/email-to-partners.jsx